import { render, staticRenderFns } from "./loginregister.vue?vue&type=template&id=7089935a&scoped=true&"
import script from "./loginregister.vue?vue&type=script&lang=js&"
export * from "./loginregister.vue?vue&type=script&lang=js&"
import style0 from "./loginregister.vue?vue&type=style&index=0&id=7089935a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089935a",
  null
  
)

export default component.exports